import { ComponentStyleConfig } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';

export const Menu: ComponentStyleConfig = {
  baseStyle: {
    list: {
      borderRadius: 4,
      shadow: 'lg',
      borderColor: 'M.30',
      overflow: 'hidden',
      zIndex: 'popover',
      color: 'textBase',
      minWidth: 112,
      padding: 0,
    },
    item: {
      height: 49,
      px: 4,
      py: 0,
      fontSize: 'sm',
      bg: 'M.20',
      _hover: {
        bg: transparentize('M.20', 0.72),
      },
    },
  },
};
